import {
    GETUSERNAMECONTACTSUGGESTION_SUCCESS,
    GETUSERNAMECONTACTSUGGESTION_FAILED,
    RESET_GETUSERNAMECONTACTSUGGESTION,
    LOADING_GETUSERNAMECONTACTSUGGESTION,
    NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERNAMECONTACTSUGGESTION:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETUSERNAMECONTACTSUGGESTION_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETUSERNAMECONTACTSUGGESTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETUSERNAMECONTACTSUGGESTION:
            return (state = initialState);
        default:
            return state;
    }
};